import type { CSSProperties } from 'react';

interface Star {
  left: string;
  top: string;
  delay: string;
  duration: string;
  scale: number;
  extra?: boolean;
}

const STARS: Star[] = [
  { left: '14%', top: '18%', delay: '0s', duration: '2.8s', scale: 1 },
  { left: '78%', top: '12%', delay: '0.6s', duration: '3.4s', scale: 0.7 },
  { left: '88%', top: '36%', delay: '1.4s', duration: '2.4s', scale: 1.2 },
  { left: '22%', top: '42%', delay: '0.2s', duration: '3.8s', scale: 0.6 },
  { left: '70%', top: '48%', delay: '1.8s', duration: '2.9s', scale: 0.85 },
  { left: '8%', top: '62%', delay: '1.1s', duration: '3.2s', scale: 1 },
  { left: '84%', top: '68%', delay: '0.4s', duration: '2.6s', scale: 0.75 },
  { left: '40%', top: '16%', delay: '2.2s', duration: '3.6s', scale: 0.55 },
  { left: '32%', top: '28%', delay: '0.8s', duration: '2.2s', scale: 0.9, extra: true },
  { left: '60%', top: '24%', delay: '1.6s', duration: '3.1s', scale: 0.65, extra: true },
  { left: '16%', top: '74%', delay: '0.3s', duration: '2.7s', scale: 0.8, extra: true },
  { left: '92%', top: '22%', delay: '1.9s', duration: '3.3s', scale: 1.1, extra: true },
];

export function MythicFx({ motes, rich }: { motes: boolean; rich: boolean }) {
  return (
    <span className="fx fx--mythic" aria-hidden="true">
      <span className="fx__drift fx__drift--a">
        <span className="fx__nebula fx__nebula--a" />
      </span>
      {rich && (
        <span className="fx__drift fx__drift--b">
          <span className="fx__nebula fx__nebula--b" />
        </span>
      )}
      <span className="fx__vignette" />
      {motes && (
        <span className="fx__drift fx__drift--stars">
          <span className="fx__stars">
            {STARS.map((star, index) => (
              <i
                key={index}
                className={star.extra ? 'is-extra' : undefined}
                style={
                  {
                    '--x': star.left,
                    '--y': star.top,
                    '--delay': star.delay,
                    '--time': star.duration,
                    '--s': star.scale,
                  } as CSSProperties
                }
              />
            ))}
          </span>
        </span>
      )}
      <span className="fx__rift" />
      <span className="fx__rift fx__rift--hot" />
      <span className="fx__chroma" />
      <span className="fx__glitch">
        <i />
        <i />
        <i />
      </span>
    </span>
  );
}
